import { UserManagementConstants } from './UserManagement.constants';

const initialState = {
  authorized: false,
  userData: null,
  loading: false,
  loginError: null,
  accountDetails: {},
  locales: [],
  subUserMenuMapping: {}
};

const UserNewReducer = (state = initialState, action) => {
  switch (action.type) {
    // --- Get Segments clause values ---
    case UserManagementConstants.GET_AUTH_LOGIN_REQUEST:
      return {
        ...state,
        loading: true,
        error: false
      };

    case UserManagementConstants.GET_AUTH_LOGIN_SUCCESS:
      return {
        ...state,
        ...action.payload,
        loading: false,
        error: false
      };

    case UserManagementConstants.GET_AUTH_LOGIN_ERROR:
      return {
        ...state,
        loading: false,
        error: true
      };

    case UserManagementConstants.GET_AUTH_LOGOUT:
      return {};

    // --- Get Account Details ---
    case UserManagementConstants.GET_AUTH_ACCOUNT_DETAILS_REQUEST:
      return {
        ...state,
        accountDetails: {
          loading: true,
          error: false
        }
      };

    case UserManagementConstants.GET_AUTH_ACCOUNT_DETAILS_SUCCESS:
      return {
        ...state,
        accountDetails: {
          ...action.payload,
          loading: false,
          error: false
        }
      };

    case UserManagementConstants.GET_AUTH_ACCOUNT_DETAILS_ERROR:
      return {
        ...state,
        accountDetails: {
          loading: false,
          error: true
        }
      };

    case UserManagementConstants.SET_LOCALES:
      return {
        ...state,
        locales: [...state.locales, ...action.payload]
      };
    case UserManagementConstants.GET_SUB_USER_MENU_REQUEST:
      return {
        ...state,
        subUserMenuMapping: {
          [action.payload]: {
            loading: true,
            error: false
          }
        }
      };
    case UserManagementConstants.GET_SUB_USER_MENU_SUCCESS:
      return {
        ...state,
        subUserMenuMapping: {
          [action.payload.userId]: {
            loading: false,
            error: false,
            menu: action?.payload?.menu
          }
        }
      };
    case UserManagementConstants.GET_SUB_USER_MENU_ERROR:
      return {
        ...state,
        subUserMenuMapping: {
          [action.payload]: {
            loading: false,
            error: true
          }
        }
      };

    default:
      return state;
  }
};

export default UserNewReducer;
